export function useIsValidEmail (email: string | undefined): boolean {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  return emailPattern.test(email ?? '')
}
